<div class="sidebar__wrapper">
  <div class="sidebar__widget mb-55">
      <div class="widget__search p-relative">
          <form action="#">
              <input type="text" placeholder="Search...">
              <button type="submit"><i class="far fa-search"></i></button>
          </form>
      </div>
  </div>
  <div class="sidebar__widget mb-55">
      <div class="sidebar__widget-title mb-25">
          <h3>Product Categories</h3>
      </div>
      <div class="sidebar__widget-content">
          <div class="categories">
              <div id="accordion">
                  <div class="card">
                      <div class="card-header white-bg" id="accessories">
                      <h5 class="mb-0">
                          <button class="shop-accordion-btn" data-bs-toggle="collapse" data-bs-target="#collapseAccessories" aria-expanded="true" aria-controls="collapseAccessories">
                              Accessories
                          </button>
                      </h5>
                      </div>
                      <div id="collapseAccessories" class="collapse show" aria-labelledby="accessories" data-bs-parent="#accordion">
                      <div class="card-body">
                          <div class="categories__list">
                              <ul>
                                  <li><a href="#">Catagories 1</a></li>
                                  <li><a href="#">Catagories 2</a></li>
                                  <li><a href="#">Catagories 3</a></li>
                              </ul>
                          </div>
                      </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header white-bg" id="cloth">
                      <h5 class="mb-0">
                          <button class="shop-accordion-btn collapsed" data-bs-toggle="collapse" data-bs-target="#collapsecloth" aria-expanded="false" aria-controls="collapsecloth">
                              Clothing
                          </button>
                      </h5>
                      </div>
                      <div id="collapsecloth" class="collapse" aria-labelledby="cloth" data-bs-parent="#accordion">
                      <div class="card-body">
                          <div class="categories__list">
                              <ul>
                                  <li><a href="#">Catagories 1</a></li>
                                  <li><a href="#">Catagories 2</a></li>
                                  <li><a href="#">Catagories 3</a></li>
                              </ul>
                          </div>
                      </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header white-bg" id="men">
                      <h5 class="mb-0">
                          <button class="shop-accordion-btn collapsed" data-bs-toggle="collapse" data-bs-target="#collapsemen" aria-expanded="false" aria-controls="collapsemen">
                              Men's
                          </button>
                      </h5>
                      </div>
                      <div id="collapsemen" class="collapse" aria-labelledby="men" data-bs-parent="#accordion">
                      <div class="card-body">
                          <div class="categories__list">
                              <ul>
                                  <li><a href="#">Catagories 1</a></li>
                                  <li><a href="#">Catagories 2</a></li>
                                  <li><a href="#">Catagories 3</a></li>
                              </ul>
                          </div>
                      </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="sidebar__widget mb-55">
      <div class="sidebar__widget-title mb-25">
          <h3>Latest Posts</h3>
      </div>
      <div class="sidebar__widget-content">
          <div class="rc__post-wrapper">
              <ul>
                  <li *ngFor="let b of recent_blogs" class="d-flex">
                      <div class="rc__post-thumb mr-20 ">
                          <a [routerLink]="['/pages/blog-details', b.id]">
                            <img [src]="b.img" alt="blog-1" style="width: 70px;height: 70px;">
                          </a>
                      </div>
                      <div class="rc__post-content">
                          <h6>
                              <a [routerLink]="['/pages/blog-details', b.id]">{{b.title.slice(0,20)}}</a>
                          </h6>
                          <div class="rc__meta">
                              <span> {{b.date}}</span>
                          </div>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
  </div>
  <div class="sidebar__widget mb-55">
      <div class="sidebar__widget-title mb-25">
          <h3>Recent Comments</h3>
      </div>
      <div class="sidebar__widget-content">
          <div class="rc__comments">
              <ul>
                  <li class="d-flex mb-20">
                      <div class="rc__comments-avater mr-15">
                          <img src="/assets/img/blog/comments/avater-3.png" alt="">
                      </div>
                      <div class="rc__comments-content">
                          <h6>Salim Rana</h6>
                          <p>Hi, this is a comment....</p>
                          <span>on <span class="highlight comment"> Hello world!</span></span>
                      </div>
                  </li>
                  <li class="d-flex mb-20">
                      <div class="rc__comments-avater mr-15">
                          <img src="/assets/img/blog/comments/avater-3.png" alt="">
                      </div>
                      <div class="rc__comments-content">
                          <h6>Shahnewaz Sakil</h6>
                          <p>Hi, this is a comment....</p>
                          <span>on <span class="highlight comment"> Hello world!</span></span>
                      </div>
                  </li>
              </ul>
          </div>
      </div>
  </div>
  <div class="sidebar__widget mb-55">
      <div class="sidebar__widget-title mb-25">
          <h3>Archives</h3>
      </div>
      <div class="sidebar__widget-content">
          <div class="sidebar__links">
              <ul>
                  <li><a href="#">December 2023</a></li>
                  <li><a href="#"> November 2023</a></li>
                  <li><a href="#"> September 2023</a></li>
                  <li><a href="#">November 2022</a></li>
              </ul>
          </div>
      </div>
  </div>
  <div class="sidebar__widget mb-55">
      <div class="sidebar__widget-title mb-25">
          <h3>Meta</h3>
      </div>
      <div class="sidebar__widget-content">
          <div class="sidebar__links">
              <ul>
                  <li><a href="#">Log in</a></li>
                  <li><a href="#">Entries RSS</a></li>
                  <li><a href="#">Comments RSS</a></li>
                  <li><a href="#">WordPress.org</a></li>
              </ul>
          </div>
      </div>
  </div>
</div>
